<template>
   <div class="l-modal">
      <div class="loading-modal w-full px-4 md:px-0">
          <div class="loader bg-white w-full md:w-4/5 mx-auto rounded px-4 lg:px-8 lg:pb-6" v-on-clickaway="close">
            <div class="pt-6">
                <div class="flex justify-between">
                    <div>
                    <p class="text-sm mt-4 cursor-pointer font-bold text-lg">
                        User/Vehicle info
                    </p>
                    </div>
                    <font-awesome-icon icon="times-circle" class="cursor-pointer text-red-500 text-base lg:text-xl" @click="$emit('close')" />
                </div>
                <div class="mt-8">
                <p class="font-bold">Policy Number</p>
                <p v-if="policy.policy.policy_number" class="mt-2 lg:mt-4 text-green-500 font-bold">{{policy.policy.policy_number}}</p>
                <p v-else class="mt-2 lg:mt-4 text-green-500 font-bold">Null</p>
                </div>
                <p class="font-bold mt-6 underline">Vehicle Details</p>
                <ul class="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                    <li>
                        <p>Vehicle make</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.vehicle_make}}</p>
                    </li>
                    <li>
                        <p>Vehicle model</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.vehicle_model}}</p>
                    </li>
                    <li>
                        <p>Vehicle value</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.vehicle_value}}</p>
                    </li>
                    <li>
                        <p>Plate Number</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.plate_number}}</p>
                    </li>
                    <li>
                        <p>Engine Number</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.engine_no}}</p>
                    </li>
                    <li>
                        <p>Chasis No</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.chasis_no}}</p>
                    </li>
                    <li>
                        <p>Vehicle Class</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.vehicle_class}}</p>
                    </li>
                    <li>
                        <p>Vehicle Usage</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.vehicle_usage}}</p>
                    </li>
                    <li>
                        <p>Vehicle Color</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.vehicle_color}}</p>
                    </li>
                    <li>
                        <p>Year of Make</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.year_of_make}}</p>
                    </li> 
                </ul>
                <p class="font-bold underline">User Info</p>
                <ul class="mt-4 grid gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                    <li>
                        <p>Enrollee</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.enrollee.firstname}} {{policy.policy.enrollee.lastname}}</p>
                    </li>
                    <li>
                        <p>Email</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.enrollee.email}}</p>
                    </li>
                    <li>
                        <p>Phone</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.enrollee.phone}}</p>
                    </li>
                    <li>
                        <p>Occupation</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.enrollee.occupation}}</p>
                    </li>
                    <li>
                        <p>DOB</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.enrollee.date_of_birth}}</p>
                    </li>
                    <li>
                        <p>State of residence</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.enrollee.state}}</p>
                    </li>
                    <li>
                        <p>LGA</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.enrollee.lga}}</p>
                    </li>
                    <li>
                        <p>License No</p>
                        <p class="mt-2 lg:mt-4 font-bold mb-6">{{policy.policy.driver_license}}</p>
                    </li>
                </ul>
                <hr class="mt-6"> 
                <a :href="policy.policy.valid_id" v-if="policy.policy.valid_id" target="_blank" rel="noopener noreferrer" class="mt-6 block text-green-500 underline">View User ID</a>
                <p v-else class="mt-6">Means of Id link not available</p>
                <a :href="policy.policy.plate_number_image" v-if="policy.policy.plate_number_image" target="_blank" rel="noopener noreferrer" class="mt-6 block text-green-500 underline">View Vehicle's Image with Plate Number</a>
                <p v-else class="mt-6">Vehicle's Image link not available</p>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';
export default {
    props:['policy'],
    data(){
        return {
            existing: ''
        }
    },
    methods:{
        close(){
          this.$emit('close')
        // console.log('closeee')
        }
    },
    directives: {
        onClickaway: onClickaway,
    },
    mounted(){
        console.log(this.policy)
    }
}
</script>

<style scoped>
.loader{
  position: relative;
  top: 5px;
  max-width: 1000px
}
.img{
  width: 120px
}

</style>